import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

import { ApiContractService } from 'src/app/services/api/api-contract.service';
import { ApiVerificationService } from 'src/app/services/api/api-verification.service';
import { DataService } from 'src/app/services/data.service';
import { HeaderTitle } from 'src/app/models/generic';

@Component({
  selector: 'app-esteira-apuracao',
  templateUrl: './esteira-apuracao.component.html',
  styleUrls: ['./esteira-apuracao.component.scss']
})
export class EsteiraApuracaoComponent implements OnInit, OnDestroy {
  inscricao!: Subscription;

  verificationCards: string[] = [];

  title = 'Esteira de Apuração ';

  constructor(
    private _verificationService: ApiVerificationService,
    private _activatedRoute: ActivatedRoute,
    private _dataService: DataService,
    private _apiContractService: ApiContractService
  ) {
    const title = _activatedRoute.snapshot.routeConfig?.title as HeaderTitle;
    this._dataService.setHeaderTitle(title);
  }

  ngOnInit(): void {
    this._apiContractService.clearContractsSelection();
    this.getVerificationCards();
  }

  ngOnDestroy() {
    if(this.inscricao)
      this.inscricao.unsubscribe();
  }

  getVerificationCards(): void {
    this.inscricao = this._verificationService.getAllStages().subscribe({
      next: (res) => {
        this.verificationCards = res.Data;
      }
    });
  }
}
